
import React from "react";

interface ProfileHeaderProps {
  title: string;
  subtitle: string;
}

export const ProfileHeader = ({ title, subtitle }: ProfileHeaderProps) => {
  return (
    <div className="mb-8">
      <h1 className="text-3xl font-bold text-white">{title}</h1>
      <p className="text-gray-400 mt-1">{subtitle}</p>
    </div>
  );
};
